const getProductStateIconPath = (state) => {
  switch (state) {
    case "Ignored":
      return "/images/msp/integrations/map-client-cancel-icon.svg";
    case "Not_Selected":
      return "/images/msp/choose-action-icon.svg";
    case "Provisional_Import":
      return "/images/msp/choose-action-icon.svg";
    case "Imported":
      return "/images/msp/twoway-blue-mark.svg";
    case "Mapped":
      return "/images/msp/twoway-blue-mark.svg";
    case "Auto_Imported":
      return "/images/msp/right-blue-mark.svg";
    case "Deleted":
      return "/images/msp/red-cross-circle.svg";
    case "AI_Mapped":
      return "/images/msp/twoway-purple-mark.svg";
    default:
      return "/images/msp/integrations/map-client-cancel-icon.svg";
  }
}

const productUtils = {
  getProductStateIconPath,
}

export default productUtils;